<template>
  <div>
    <div class="top-div">
      <div @click="handleBack" style="font-size: 22px;margin: 5px 10px 0 0;">
        <van-icon name="arrow-left" />
      </div>
      <div class="top-div-title">话术库</div>
    </div>
    <div class="title">
      <div :class="type===2?'qiye_ccolor':'qiye'" @click='handleChange(2)'>企业话术库</div>
      <div :class="type===3?'qiye_ccolor':'qiye'" @click='handleChange(3)'>经销商话术库</div>
      <div :class="type===1?'qiye_ccolor':'qiye'" @click='handleChange(1)'>个人话术库</div>
    </div>
    <van-search v-model="keyword" placeholder="搜索" @search="onSearch" @clear="onCancel" shape="round" />
    <div class="search">
      <van-dropdown-menu active-color="#3974c4">
        <van-dropdown-item v-model="deptId" :options="deptList" v-if="type === 3 && deptList.length > 0" />
        <van-dropdown-item :title="groupName" ref="item">
          <template>
            <multipleSelect ref="selectChild" :parentType="type" :deptId="deptId" :dataList="groupList"
              :groupItem="groupItem" @getGroupItem="getGroupItem" @getShowPopupTree="getShowPopupTree">
            </multipleSelect>
          </template>
        </van-dropdown-item>
      </van-dropdown-menu>
    </div>
    <!-- 分组 -->
    <!-- <div style="font-size: 16px;padding: 15px 20px;font-weight:bold;" @click="showPopupTree = true">{{groupName}}</div>
     -->

    <!-- 内容列表 -->
    <div class="conte" v-for="(item, index) in speechListContent" :key="index">
      <div style="display:flex;justify-content: space-between;">
        <div>
          <div>{{ item.title }}</div>
          <div style="margin-top: 5px;font-size: 14px; color:#888;" class="content">{{ item.content }}</div>
        </div>
        <div class="copy" @click="handleSend(item, index)">发送</div>
      </div>
    </div>
    <!-- <div v-if="groupList.length > 0">
      <van-tabs @change="tabchange" v-model="active" color="#8f8ee6" title-active-color="#8f8ee6">
        <van-tab v-for="item in groupList" :title="item.name" :key="item.id" style="padding:0 12px">
          <ul v-if="speechListContent.length > 0">
            <li v-for="(item, index) in speechListContent" :key="index"
              style="display:flex;justify-content: space-between;">
              <div style="flex: 1">
                <div>{{ item.title }}</div>
                <div class="content">
                  {{ item.content }}</div>
              </div>
              <div class="copy" @click="handleSend(item, index)">发送</div>
            </li>
          </ul>
        </van-tab>
      </van-tabs>
    </div> -->

    <van-empty description="暂无更多" v-if="groupList.length < 1 || speechListContent.length < 1" />
  </div>
</template>

<script>
import multipleSelect from '../../components/multipleSelect.vue'
import { flatten } from '../../utils/index'

export default {
  props: {
    href: {
      type: Object,
      default: null
    }
  },
  components: { multipleSelect },
  data () {
    return {
      selectNum: 0,
      groupList: [],
      speechListContent: [],
      active: 0,
      type: 2,
      entry: '',
      groupId: '',
      keyword: '',
      isQueryType: null,
      contactId: null,
      sessionId: null,
      accountId: null,
      memo: '',
      name: '',
      groupName: '',
      showPopupTree: false,
      groupItem: {},
      deptId: null,
      deptList: []
    }
  },
  watch: {
    deptId (val) {
      this.speechgroupList()
    }
  },
  created () {
    if (this.type === 3) {
      this.groupList = []
      this.initDeptList()
    } else {
      this.speechgroupList()
    }
    let { type, contactId, sessionId, accountId, memo, name } = this.$route.query
    this.isQueryType = type
    this.contactId = contactId
    this.sessionId = sessionId
    this.accountId = accountId
    this.memo = memo
    this.name = name
  },
  methods: {
    handleChange (val) {
      this.type = val
      if (this.type === 3) {
        this.groupList = []
        this.initDeptList()
      } else {
        this.speechgroupList()
      }
    },
    onSearch () {
      this.speechList()
    },
    onCancel () {
      this.speechList()
    },
    initDeptList () {
      this.$http
        .get("/scrm/v1/tenancy-dept/m/contentShareDeptMulTenancy", {})
        .then((res) => {
          const { code, data } = res
          if (code === 1) {
            this.deptList = []
            res.data.forEach(item => {
              if (item.deptList === null || item.deptList === undefined) {
                item.deptList = []
              }
              if (item.deptList.length > 0) {
                item.deptList.forEach(tree => {
                  tree.tenancyName = item.tenancy.name || ''
                });
                this.deptList.push(item.deptList)
              }

            })
            this.deptList = flatten(this.deptList);
            console.log(this.deptList, 'this.deptList');
            if (this.deptList.length > 0) {
              this.deptList.forEach(item => {
                item.text = item.tenancyName + '/ ' + item.name
                item.value = item.id
              })
              this.deptId = this.deptList[0].id
              this.speechgroupList()
            } else {
              this.groupItem = {}
              this.groupId = null
              this.groupList = []
              this.groupName = ''
              this.speechListContent = []
            }
          }
        });
    },
    //查询话术库分组
    speechgroupList () {
      this.$http
        .get("/scrm/v1/ct-speech-group/m/findTreeMulTenancy", {
          params: {
            owner: this.type,
            deptId: this.deptId
          },
        })
        .then((res) => {
          if (res.code === 1) {
            this.groupList = []
            res.data.forEach(item => {
              if (item.tree === null || item.tree === undefined) {
                item.tree = []
              }
              if (item.tree.length > 0) {
                item.tree.forEach(tree => {
                  tree.tenancyName = item.tenancy.name || ''
                });
                this.groupList.push(item.tree)
              }
            })


            console.log(this.groupList, 'this.groupList');
            this.groupList = flatten(this.groupList); // arr2 [0, 1, 2, 3, 4, 5]
            console.log(this.groupList, 'this.groupList222222222222222222');

            if (this.groupList.length > 0) {
              this.groupItem = this.groupList[0]
              this.groupId = this.groupList[0].id
              this.groupName = this.groupList[0].text
              this.speechList()
            } else {
              this.groupItem = {}
              this.groupId = null
              this.groupName = ''
              this.speechListContent = []
            }
          }
        });
    },
    // tabchange (name, title) {
    //   this.keyword = ''
    //   this.groupList.forEach(item => {
    //     if (item.name === title) {
    //       this.groupId = item.id
    //       this.speechList()
    //     }
    //   })
    // },
    //查询话术库内容
    speechList () {
      this.$http
        .get("/scrm/v1/ct-speech/m/findListByPage", {
          params: {
            owner: this.type,
            groupId: this.groupId,
            page: 1,
            pageCount: 10000,
            title: this.keyword,
            deptId: this.deptId
          },
        })
        .then((res) => {
          if (res.code === 1) {
            this.speechListContent = res.data.records;
          }
        })
    },
    // getShowPopupTree
    getShowPopupTree (val) {
      this.showPopupTree = val
    },
    // getGroupItem
    getGroupItem (val) {
      console.log(val, 'val');
      this.groupItem = val
      this.groupId = val.id
      this.groupName = val.text
      this.speechList()

      if (val.children === null || val.children === undefined) {
        val.children = []
      }
      if (this.selectNum > 0 && val.children.length < 1) {
        this.$refs.item.toggle();
      }
      this.selectNum++
      console.log(this.groupId, 'this.groupId')
    },
    // getGroupName (val) {
    //   this.groupName = val
    //   console.log(this.groupName, 'this.groupName')
    // },
    handleSend (item, index) {
      console.log(item, index, 'item, index');
      this.$router.push({ path: '/chatIndex', query: { type: this.isQueryType, contactId: this.contactId, sessionId: this.sessionId, accountId: this.accountId, memo: this.memo, name: this.name, inputText: item.content } })
    },
    // 返回
    handleBack () {
      this.$router.push({ path: '/chatIndex', query: { type: this.isQueryType, contactId: this.contactId, sessionId: this.sessionId, accountId: this.accountId, memo: this.memo, name: this.name } })
    },
  },
};
</script>
 
<style lang="less" scoped>
.popup {
  padding-bottom: 65px;
  .popup-title {
    padding: 18px 20px;
    font-weight: bold;
    font-size: 16px;
  }
  .popup-content {
    padding: 18px 16px;
    font-size: 14px;
    line-height: 24px;
  }
  .popup-btn {
    position: fixed;
    bottom: 0;
    width: 100%;
    /deep/.van-button--primary {
      width: 100%;
      background-color: #3974c4;
      border: 0;
      line-height: 45px;
      height: 45px;
    }
  }
}
.content {
  margin-top: 5px;
  font-size: 14px;
  color: #888;
  max-width: 300px;
  word-break: break-all;
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  -webkit-box-orient: vertical;
}
.top-div {
  width: 100%;
  height: 60px;
  line-height: 60px;
  display: flex;
  align-items: center;
  padding: 0 0 0 12px;
  background-color: #3974c4;
  > div {
    line-height: 50px;
    font-size: 18px;
    color: #fff;
  }
}
.copy {
  width: 45px;
  height: 25px;
  min-width: 45px;
  margin-left: 10px;
  border: 1px solid #3974c4;
  color: #3974c4;
  font-size: 13px;
  border-radius: 15px;
  text-align: center;
  line-height: 25px;
}
.title {
  padding: 10px 20px;
  font-size: 14px;
  display: flex;
  border-bottom: 1px solid #dedede;
  .qiye {
    width: 100px;
    height: 30px;
    background-color: #f0f0f2;
    text-align: center;
    line-height: 30px;
    border-radius: 18px;
    margin-right: 10px;
  }
  .qiye_ccolor {
    width: 100px;
    height: 30px;
    background-color: #e6e6ff;
    border: 1px solid #9494e8;
    text-align: center;
    line-height: 30px;
    border-radius: 18px;
    margin-right: 10px;
  }
}
.conte {
  line-height: 20px;
  padding: 15px 20px 15px 15px;
  font-size: 14px;
  border-bottom: 1px solid #ccc;
  cursor: pointer;
}
.search {
  width: 100%;
  padding: 0 10px 0 5px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  /deep/ .van-dropdown-menu {
    width: 100%;
  }
  /deep/ .van-dropdown-menu__bar {
    // width: 80px;
    display: flex;
    justify-content: space-between;
    box-shadow: 0 0;
    font-size: 15px;
  }
  /deep/.van-search {
    width: 70%;
  }
}
</style>
